import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import AddAssetCountingSupplyOfficerWidget from '../../../widgets/durableArticlesWidget/manageDurableArticles/AddAssetCountingSupplyOfficerWidget'
import { getDisplayAddAssetCountPage } from '../../../redux/actions/accountingAssetClosure'

export default function AddAssetCountingSupplyOfficer() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const assetCountId = sessionGetItemStr('initialId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    // setIsLoading(true)
    // startLoading()
    try {
      const _schema = await getDisplayAddAssetCountPage(assetCountId)
      console.log('ggg => ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      // if (e?.response?.data) {
      //   setError({
      //     statusCode: e.response.data.status,
      //     errorMessage: e.response.data.errors?.message,
      //   })
      // } else {
      //   setError({})
      // }
    }
    // doneLoading()
    // setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpenseApprover>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <AddAssetCountingSupplyOfficerWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )

  const mockSchema = {
    affectedRows: 0,
    message: null,
    didError: false,
    errorMessage: null,
    model: {
      projectInfo: {
        projectCodeLabel: 'รหัสโครงการ : ',
        projectCode: '66-00018',
        projectNameLabel: 'ชื่อโครงการ : ',
        projectName: 'ทดสอบอนุมัติหลายโครงการ 002',
        durationLabel: 'ระยะเวลาดำเนินงาน : ',
        duration: '10/มี.ค./2566 - 10/มี.ค./2567',
        countOfSubProjectLabel: 'โครงการย่อย : ',
        countOfSubProject: '3',
        isPurchaseOfDurableGoodsLabel: 'งบครุภัณฑ์ : ',
        isPurchaseOfDurableGoods: 'มี',
        contractNoLabel: 'เลขที่ข้อตกลง : ',
        contractNo: '66-P1-0011',
        coordinatorLabel: 'ผู้ประสาน : ',
        coordinator: 'นางสาวสุภัทราเรืองวานิช (สำนัก 1)',
        responsiblerLabel: 'ผู้รับผิดชอบโครงการ : ',
        responsibler: 'นายโบวา เยล',
        projectStatusLabel: 'สถานะโครงการ : ',
        projectStatus: 'ดำเนินการ',
        numOfPeriodLabel: null,
        numOfPeriod: null,
        periodLabel: null,
        period: null,
        subProjectName: null,
        subPjectCode: null,
        projectStartDate: '2023-03-10T12:00:00',
        projectEndDate: '2024-03-10T12:00:00',
      },
      form: {
        periodOption: {
          options: [
            { disabled: false, label: 'งวดที่ 1 (01/ม.ค./2566 - 30/มิ.ย./2566)', value: '1' },
            { disabled: false, label: 'งวดที่ 2 (01/ก.ค./2566 - 30/พ.ย./2566)', value: '2' },
            { disabled: false, label: 'งวดที่ 3 (01/ธ.ค./2566 - 31/ธ.ค./2566)', value: '3' },
          ],
          name: 'periodOption',
          label: 'เลือกงวดโครงการ',
          value: null,
          validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกงวดโครงการ' }],
        },
        isEnableEdit: true,
        values: [
          {
            id: '791E4EBE-DCB2-4D05-97B4-D19666FFA7D5',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: null,
            assetCode: 'AS-791E4EBE',
            assetName: 'Macbook air',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '7E968886-D3DE-455A-906C-D15D1F56FFAF',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-7E968886',
            assetName: 'notebook asus',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '806FBA80-C39B-4C92-B751-746D04F69CA2',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-806FBA80',
            assetName: 'notebook acer',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '8232D275-28AD-4F94-B80E-52D59A7A964E',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-8232D275',
            assetName: 'notebook dell',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '825208C1-73B4-490C-A3B1-F9D2EC4FC781',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-825208C1',
            assetName: 'notebook msi',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '850D716A-3F1B-47A2-A29B-D86B18E53449',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-850D716A',
            assetName: 'mouse hp',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
          {
            id: '870C906E-BCA1-47FA-B0FE-72B9386D94B5',
            registerDocNo: '66-00018-66-000029',
            assetBillNo: '8888',
            assetCode: 'AS-870C906E',
            assetName: 'All in one Computer',
            assetType: 'ครุภัณฑ์สำนักงาน',
            assetStatusCode: '1',
            assetStatus: 'อยู่ในโครงการ',
            assetQrCodePathFile: null,
            totalPrice: 20,
            editMessage: null,
            isEnableEdit: false,
          },
        ],
        requestRegister: {
          header: 'ระบุคำอธิบายขอขึ้นทะเบียน',
          note: {
            name: 'note',
            label: 'ระบุคำอธิบายขอขึ้นทะเบียน',
            value: '',
            validators: [
              { type: 'REQUIRED', value: null, errorMessage: 'กรุณากรอกคำอธิบายขอขึ้นทะเบียน' },
            ],
          },
          buttonText: { requestRegister: 'ส่งขอขึ้นทะเบียน', cancel: 'ยกเลิก' },
        },
      },
      header: 'แสดงรายการตรวจนับ',
      subHeader: '',
      disabled: false,
      isApprover: false,
    },
  }
}
